import React, { useEffect, useRef, useState } from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter, Label } from 'reactstrap';
import styled from 'styled-components';
import FileBase64 from 'react-file-base64';
import Cropper, { ReactCropperElement } from "react-cropper";

import BackButton from '../custom/BackButton';
import ActionIcon from '../custom/ActionIcon';
import { blobToBase64, compressImageFromBase64, createdUpdatedInfo, getTsDate, notify } from '../../utils';
import DragAndDropFileUpload from '../DragDropUpload';
import { FileWithBase64, IEmployee, IUser } from '../../globals/interfaces';
import apiClient from '../../apiClient';
import { useAppContext } from '../../context';
import _ from 'lodash';
import ImageCropper from '../ImageCropper';

interface Props {
    modal: boolean;
    setModal: (state: boolean) => void;
    selectedEmployee: IEmployee;
    setSelectedEmployee: React.Dispatch<React.SetStateAction<IEmployee>>;
    user: IUser;
}

export default function ModalUpdatePhoto({
    modal,
    setModal,
    selectedEmployee,
    setSelectedEmployee,
    user
}: Props) {

    const { setLoading } = useAppContext();
    const [file, setFile] = useState<FileWithBase64>();
    const cropperRef = useRef<ReactCropperElement>(null);

    const updateUserPhoto = async () => {
        const cropper = cropperRef.current?.cropper;
        if (!file || !cropper) return;

        setLoading(true);
        const croppedBase64 = cropper.getCroppedCanvas().toDataURL();
        const compressedBase64 = await compressImageFromBase64(croppedBase64);
        const useFile = { ...file };
        useFile.base64 = compressedBase64;

        const { s_email, s_photo_link } = selectedEmployee;
        try {
            const { data } = await apiClient.put(`/user-photo`, {
                employee_id: selectedEmployee.id,
                s_email: s_email.toLowerCase(),
                s_photo_link,
                file: useFile,
                updatedBy: user.s_email,
                updated: getTsDate()
            });
            setSelectedEmployee(prev => {
                const copy = _.cloneDeep(prev);
                copy.s_photo_link = data.s_file_link;
                return copy;
            })
            toggle();
            notify('Picture updated');
        } catch (err) {
            alert(err);
        }
        setLoading(false);
    }

    const toggle = () => setModal(!modal);

    useEffect(() => {
        setFile(undefined);
    }, []);

    return (
        <Modal isOpen={modal} toggle={toggle} size={'lg'}>
            <ModalHeader className={'d-flex'}>
                <HeaderContainer>
                    <BackButton onClick={toggle} />
                    <h4 className={'pl-2'}>Update Photo</h4>
                </HeaderContainer>
            </ModalHeader>
            <ModalBody>
                {/* <DragAndDropFileUpload 
                    onDone={(file: FileWithBase64) => setFile(file)}
                /> */}
                <FileBase64
                    onDone={setFile}
                />
                {
                    file && (
                        <Cropper
                            src={file.base64}
                            style={{ height: 400, width: "100%" }}
                            guides={true}
                            aspectRatio={1}
                            // cropBoxResizable={false}
                            // minCropBoxHeight={100}
                            // minCropBoxWidth={100}
                            ref={cropperRef}
                        />
                    )
                }
            </ModalBody>
            <ExpandedFooter>
                <FooterContentContainer>
                    <FooterButtonsContainer>
                        <ActionIcon type={'save'} onClick={() => updateUserPhoto()} disabled={!file} />
                    </FooterButtonsContainer>
                </FooterContentContainer>
            </ExpandedFooter>
        </Modal>
    );
}

const HeaderContainer = styled.div`
    width: 100%;
    display: flex;
    align-items: center;
`;

const ExpandedFooter = styled(ModalFooter)`
    width: 100%;
`;

const FooterContentContainer = styled.div`
    width: 100%;
`;

const FooterButtonsContainer = styled.div<{ update?: boolean }>`
    width: 100%;
    display: flex;
    justify-content: ${p => p.update ? 'space-between' : 'flex-end'};
`;